import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import { PermissionIcon } from '../agent-dashboard/assets';
import { AutoPushIcon, InteractedIcon, UserCreateIcon, ViewIcon } from './assets';
import { Skeleton } from '../ui/skeleton';
import { agentContentHooks } from '@/manager';
import { cn } from '@/lib/utils';
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react';

/** 智能体内容管理-卡片概览 */
export const DataOverview: React.FC = () => {
  const { t } = useTranslation();

  const { loading, contentStatsData } = agentContentHooks.useContentStats();

  // 统计数据
  const stats = useMemo(() => {
    return [
      {
        title: t('agent_dashboard.content_management.auto_push_count'),
        count: contentStatsData.autoPush || 0,
        icon: <AutoPushIcon />,
      },
      {
        title: t('agent_dashboard.content_management.user_creation_count'),
        count: contentStatsData.total || 0,
        icon: <UserCreateIcon />,
      },
      {
        title: t('agent_dashboard.content_management.interacted_count'),
        // count: contentStatsData.interactionRate || 0,
        count: null,
        rate: contentStatsData.interactionRate || 0,
        icon: <InteractedIcon />,
      },
      {
        title: t('agent_dashboard.content_management.view_rate'),
        count: '-',
        icon: <ViewIcon />,
      },
    ]
  }, [contentStatsData]);

  return (
    <div className='flex gap-5 flex-col lg:flex-row'>
      {stats.map((stat, index) => (
        <div
          key={index}
          className='w-[22rem] max-w-[22rem] bg-white rounded-lg  border border-[rgba(233,234,235,1)] p-6 py-6 flex space-x-4 shadow-[0px_1px_2px_rgba(10,13,18,0.05)]'
        >
          <div className={`size-10 border border-[rgba(213,215,218,1)] rounded-md flex items-center justify-center shadow-sm flex-shrink-0`}>
            {stat.icon}
          </div>
          <div className='flex-1 space-y-2'>
            <div className='text-sm text-[rgba(102,112,133,1)] font-semibold'>{stat.title}</div>
            {loading && <Skeleton className='h-9 w-20 rounded' />}
            {!loading && (
              <>
                {stat.count !== null && stat.count !== undefined && (
                  <div className='text-3xl font-semibold text-[rgba(16,24,40,1)]'>{stat.count}</div>
                )}
                {stat.rate !== null && stat.rate !== undefined && (
                  <div className='text-3xl font-semibold text-[rgba(16,24,40,1)]'>
                    {stat.rate === 0 ? 0 : (Number(stat.rate) * 100).toFixed(2)}%
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
